<template>
  <el-dialog
    title="审批详情"
    :visible.sync="dialogVisible"
    class="approveDialogWrap"
    width="66%"
  >
    <el-table
      ref="multipleTable"
      :data="itemApproveProcessVOs"
      size="mini"
	  height="560px"
      border
      :key="updated"
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        :sortable="item.sortEnable"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="dialogVisible = false">取 消</el-button>
      <!-- <el-button type="primary" @click="handleConfirm">确 定</el-button> -->
    </span>
  </el-dialog>
</template>

<script>
import {
  getApproveListService, //查询审批列表
} from "@/services/approveServices";
export default {
  name: "dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      itemApproveProcessVOs: [], //审批信息列表
      tableColumnDatas: [
        { class: "approveUserName", labelName: "姓名", sortEnable: false },
        { class: "deptName", labelName: "部门", sortEnable: false },
        { class: "jobName", labelName: "岗位", sortEnable: false },
        { class: "statusName", labelName: "状态", sortEnable: false },
        { class: "opinion", labelName: "审批意见", sortEnable: false },
        { class: "updateTime", labelName: "操作时间", sortEnable: false },
      ],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("updateVisible", { val });
      },
    },
  },
  watch: {
    dialogVisible(value) {
      if (value) this.getApproveList();
    },
  },

  methods: {
    //获取审批信息列表
    getApproveList() {
      let param = {};
      param.itemId = this.itemId; //审批对象id
      param.approveClass = this.type; //审批类型
      getApproveListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.itemApproveProcessVOs = res.data; //审批流历史审批数据
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-dialog__body {
  padding: 10px;
}
/deep/.el-dialog__footer {
  padding: 10px 20px 10px;
}
.approveDialogWrap {
  .backWrap {
    display: flex;
    margin: 10px 0;
    align-items: center;

    .label {
      width: 60px;
    }

    .content {
      flex: 1;
    }
  }

  .dialog-footer {
    text-align: center;
    width: 100%;
    display: inline-block;
  }
}
</style>
